export default [
	'cabinets',
	'carpet_and_floor_sales_and_installation',
	'painters',
	// The comma is not a typo, its was carelessness ☹️
	'pool_sales,_service_and_installation',
	'roofers',
	'window_sales_and_installation',
];
